export default __webpack_public_path__ + "static/media/map-bg.7f6d0010.png";